import React from 'react';
import ItemDetailTable from './ItemDetailTable';

const Index = ({ source = {}, diccionario = [] }) => {
  return (
    <table className="table table-bordered">
      <tbody>
        {diccionario.map((item, index) => (
          <React.Fragment key={index}>
            <ItemDetailTable {...item} source={source} />
          </React.Fragment>
        ))}
      </tbody>
    </table>
  );
};

const DynamicTableDetail = React.memo(Index);

export default DynamicTableDetail;
